// Validação de telefone Guatemala
// Formato oficial: 8 dígitos, inicia com 2,3,4,5,6,7 ou 8 dependendo da operadora/serviço.
// Referência comum: celular geralmente inicia 3,4,5,6,7; porém há linhas que podem usar 2 ou 8.
// Ajuste conforme regra de negócio: aqui permitiremos 3-7 para celulares e opcionalmente aceitar outros prefixos via flag.

export interface GuatemalaPhoneValidationOptions {
  allowFixedLine?: boolean // se true permite também prefixos 2 e 8
  requireCountryCode?: boolean // se true exige exibição e validação do +502
}

// Extrai somente os 8 dígitos do número local (descartando código do país se presente na string).
export function extractGuatemalaLocalDigits(value: string): string {
  const digits = value.replace(/\D/g, '')
  // Remove código do país 502 caso o usuário cole um número completo (+502... ou 502...)
  if (digits.startsWith('502')) {
    return digits.slice(3, 11)
  }
  return digits.slice(0, 8)
}

// Formata os dígitos locais (até 8) no padrão +502 1234 5678
export function formatGuatemalaPhone(localDigits: string): string {
  const safe = localDigits.slice(0, 8)
  const first = safe.slice(0, 4)
  const second = safe.slice(4)
  return second ? `+502 ${first} ${second}` : first ? `+502 ${first}` : '+502 '
}

export function validateGuatemalaMobile(value: string, options?: GuatemalaPhoneValidationOptions) {
  const localDigits = extractGuatemalaLocalDigits(value)
  // Nova regra: qualquer sequência de 8 dígitos é aceita; sem validação de prefixo.
  const patternBase = /^\d{8}$/
  const valid = patternBase.test(localDigits)

  let reason: string | undefined
  if (localDigits && localDigits.length < 8) {
    reason = 'Debe contener 8 dígitos'
  } // Não mostra mensagem quando vazio nem quando há 8 dígitos válidos

  return {
    valid,
    normalized: localDigits, // somente os 8 dígitos locais
    international: valid && localDigits.length === 8 ? `+502${localDigits}` : undefined,
    display: formatGuatemalaPhone(localDigits),
    reason,
  }
}
